import React from 'react';

function CartDrawer({ cart, total, onUpdateQty, onClear, onClose }) {
  return (
    <div className="ecom-drawer-overlay" onClick={onClose}>
      <div className="ecom-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="ecom-drawer-header">
          <h2>Shopping Cart ({cart.reduce((s, i) => s + i.qty, 0)})</h2>
          <button className="ecom-drawer-close" onClick={onClose}>&times;</button>
        </div>

        <div className="ecom-drawer-body">
          {cart.length === 0 ? (
            <div className="ecom-drawer-empty">
              <span className="ecom-drawer-empty-icon">🛒</span>
              <p>Your cart is empty</p>
            </div>
          ) : (
            cart.map((item) => (
              <div key={item.id} className="ecom-cart-item">
                <div className="ecom-cart-item-image" style={{ background: item.color + '15' }}>
                  <span>{item.image}</span>
                </div>
                <div className="ecom-cart-item-info">
                  <h4>{item.name}</h4>
                  <span className="ecom-cart-item-price">${item.price.toFixed(2)}</span>
                </div>
                <div className="ecom-cart-item-qty">
                  <button onClick={() => onUpdateQty(item.id, item.qty - 1)}>-</button>
                  <span>{item.qty}</span>
                  <button onClick={() => onUpdateQty(item.id, item.qty + 1)}>+</button>
                </div>
                <span className="ecom-cart-item-total">${(item.price * item.qty).toFixed(2)}</span>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <div className="ecom-drawer-footer">
            <div className="ecom-drawer-summary">
              <div className="ecom-drawer-row">
                <span>Subtotal</span>
                <span>${total.toFixed(2)}</span>
              </div>
              <div className="ecom-drawer-row">
                <span>Shipping</span>
                <span className="ecom-free">Free</span>
              </div>
              <div className="ecom-drawer-row total">
                <span>Total</span>
                <span>${total.toFixed(2)}</span>
              </div>
            </div>
            <button className="ecom-checkout-btn">Proceed to Checkout</button>
            <button className="ecom-clear-btn" onClick={onClear}>Clear Cart</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CartDrawer;
